import React from 'react';
import SectionWrapper from '../ui/SectionWrapper';

const About = () => {
  return (
    <SectionWrapper id="about" className="bg-white">
      <div className="grid md:grid-cols-12 gap-12 items-start" itemScope itemType="https://schema.org/AboutPage">
        <div className="md:col-span-4">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">About Me</h2>
          <div className="h-1 w-20 bg-teal-500 rounded-full mb-6"></div>
          <p className="text-slate-500 italic">
            "Security isn't just a technical layer; it's the foundation of institutional trust."
          </p>
        </div>
        <div className="md:col-span-8 space-y-6 text-lg text-slate-600 leading-relaxed">
          <p>
            I am a strategist and technology leader with over <strong className="text-slate-900 font-semibold">25+ years of experience</strong> at the intersection of banking, cybersecurity, and global security operations.
          </p>
          <p>
            Throughout my career, I have specialized in building and securing mission-critical platforms for major institutions. My experience includes managing the enterprise biometrics platform for <strong className="text-slate-900 font-semibold">BDO Unibank</strong> (the Philippines' largest bank), leading the technical architecture for <strong className="text-slate-900 font-semibold">Security Bank's</strong> new retail app, and serving as a Regional Project Manager for <strong className="text-slate-900 font-semibold">Interpol</strong>.
          </p>
          <p>
            I focus on <strong className="text-teal-700 font-medium">Zero-Trust architectures</strong>, identity verification, and fraud prevention. Whether advising startups on rapid execution or helping enterprises scale secure data platforms, my goal is to ensure that technology serves as a reliable bridge between organizations and their users.
          </p>
          
          <div className="pt-4 grid grid-cols-2 md:grid-cols-3 gap-6">
            <div itemScope itemType="https://schema.org/PropertyValue">
              <h4 className="font-bold text-slate-900 text-3xl" itemProp="value">25+</h4>
              <p className="text-sm text-slate-500" itemProp="name">Years of Experience</p>
            </div>
            <div itemScope itemType="https://schema.org/PropertyValue">
              <h4 className="font-bold text-slate-900 text-3xl" itemProp="value">Tier-1</h4>
              <p className="text-sm text-slate-500" itemProp="name">Banking Strategy</p>
            </div>
            <div itemScope itemType="https://schema.org/PropertyValue">
              <h4 className="font-bold text-slate-900 text-3xl" itemProp="value">Global</h4>
              <p className="text-sm text-slate-500" itemProp="name">Security Operations</p>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default About;